import { Box, Collapse, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import React from "react";
import { api } from "../../../api";
import { useCashiersStyles } from "../useCashiersStyles";

export const CashierDetailRow = (props: any) => {
  const { row } = props;
  const classes = useCashiersStyles();
  const [open, setOpen] = React.useState(false);
  const [denominationData, setDenominationData] = React.useState<any>([]);

  const showData=async(payCode:string, headId:number, detailId:number)=>{
    if (payCode === "CASH" || payCode === "CARD") {
      if (open === false) {
        const result = await api.get(`cashier-reconciliation/paycode-details/${row.pay_code}?recons_head_id=${headId}&recons_detail_id=${detailId}`)
        setDenominationData(payCode === "CASH" ? result.cash_array : result.card_array)
        setOpen(!open);
      }
      else {
        setOpen(!open);
      }
    }
  };
  return (
    <React.Fragment>
      <TableRow className={classes.tableRow}
        onClick={ () => {
          setOpen(false);
          showData(row.pay_code, row.recons_head_id, row.recons_detail_id)
        }}
      >
        <TableCell>{row.pay_code}</TableCell>
        <TableCell align="right">{row.bill_count}</TableCell>
        <TableCell align="right">{row.deduction_actual_amount}</TableCell>
        <TableCell align="right">{row.deduction_system_amount}</TableCell>
        <TableCell align="right">{row.total_actual_amount}</TableCell>
        <TableCell align="right">{row.total_system_amount}</TableCell>
      </TableRow>
      <TableRow >
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {denominationData.length === 0 ? (
              <Box margin={3}>
                <Typography variant="h6" style={{ fontWeight: "bold" }}>No Data to show details</Typography>
              </Box>
            ) : (
              row.pay_code === "CASH" ? (
                <Box margin={3}>
                  <Typography variant="h6" gutterBottom component="div" className={classes.denominationTitle}>
                    Cash Denominations
                  </Typography>
                  <Table size="small" aria-label="denominations">
                    <TableBody>
                      {denominationData?.map((i: any) =>
                        <TableRow >
                          <TableCell component="th" scope="row">
                            {i.denomination_amount}
                          </TableCell>
                          <TableCell>
                            <Typography style={{ fontSize: "20px" }}>*</Typography>
                          </TableCell>
                          <TableCell >{i.quantity}</TableCell>
                          <TableCell>
                            <Typography style={{ fontSize: "15px" }}>=</Typography>
                          </TableCell>
                          <TableCell align="right">
                            {parseFloat(i.total).toFixed(3)}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Box>
              ) : (
                <Box margin={3}>
                  <Typography variant="h6" gutterBottom component="div" className={classes.denominationTitle}>
                    Card Details
                  </Typography>
                  <Table size="small" aria-label="denominations">
                    <TableHead>
                      <TableRow>
                        <TableCell>Bank Code</TableCell>
                        <TableCell >Card Code</TableCell>
                        <TableCell align="center">Sub Actual Amount</TableCell>
                        <TableCell align="center">Sub System Amount</TableCell>
                        <TableCell align="right">Total Actual Amount</TableCell>
                        <TableCell align="right">Total System Amount</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {denominationData?.map((i: any) =>
                        <TableRow >
                          <TableCell component="th" scope="row">
                            {i.bank_code}
                          </TableCell>
                          <TableCell>
                            {i.card_code}
                          </TableCell>
                          <TableCell align="center">{i.sub_actual_amount}</TableCell>
                          <TableCell align="center">{i.sub_sys_amount}</TableCell>
                          <TableCell align="right">{i.total_actual_amount}</TableCell>
                          <TableCell align="right">{i.total_system_amount}</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </Box>
              ))}
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}